import { useState } from "react";
import { TextField } from "@material-ui/core";
import MaskedField from "components/UI/Fields/MaskedField";
import useValidations from "hooks/useValidations";
import { ContractRowMovementStore } from "store";
import { lang } from "i18nLang";

interface IProps {
  classes: any;
  onChangeData: (data: any) => void;
  onBlurInput: (field: string, value: any, isValid: boolean) => void;
}

const AdditiveQuantityForm = ({
  classes,
  onChangeData,
  onBlurInput,
}: IProps) => {
  const [data, setData] = useState({
    code: "",
    quantity: "",
  });

  const { validated, validateFields } = useValidations({
    code: {
      required: true,
      custom: function (value) {
        return ContractRowMovementStore.verifyExistedCode(value);
      },
    },
    quantity: { required: true, greaterThan: { valueToCompare: 0 } },
  });

  const handleChangeInput = (ev) => {
    const { name, value } = ev.target;
    const newData = { ...data };
    newData[name] = value;
    setData(newData);
    onChangeData(newData);
  };

  const handleBlurInput = (ev) => {
    const { name, value } = ev.target;
    const valid = validateFields({ [name]: value });
    onBlurInput(name, value, valid);
  };

  const handleBlurInputQtt = (ev, value) => {
    const valid = validateFields({ quantity: value });
    onBlurInput("quantity", value, valid);
  };

  return (
    <form onSubmit={(ev) => ev.preventDefault()}>
      <TextField
        name="code"
        label={lang("fields.code")}
        className={classes.input}
        color="secondary"
        value={data.code}
        onChange={handleChangeInput}
        onBlur={handleBlurInput}
        error={!validated.code.valid}
        helperText={validated.code.text}
        fullWidth
      />
      <MaskedField
        name="quantity"
        label={lang("fields.quantity")}
        className={classes.input}
        color="secondary"
        decimalScale={5}
        fixedDecimalScale={true}
        value={data.quantity}
        onChange={handleChangeInput}
        onBlur={handleBlurInputQtt}
        onKeyDown={(ev) => ev.stopPropagation()}
        error={!validated.quantity.valid}
        helperText={
          validated.quantity.text || lang("addsAndCancels.qttAddHelp")
        }
        margin="normal"
        fullWidth
      />
    </form>
  );
};

export default AdditiveQuantityForm;
